import CrewCard from '@pages/Manage/components/CrewCard.tsx';

import styles from './CrewRosterWidget.module.scss';

export const CrewRosterWidget = () => <CrewCard className={styles.card} headDivider fillHeight />;

export default CrewRosterWidget;
